import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import phFemale from "../../../assets/images/blurred2/workBalance/work-balance-female.webp";
import phMale from "../../../assets/images/blurred2/workBalance/work-balance.webp";
import ImageLoader from "../../../components/ImageLoader";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url, nextPageRoute } from "../../../utils/modules";

const imagesToPreload = [
  "/workSituation/balance.png",
  "/workSituation/gear.png",
  "/imoji/thinking.png",
];
const buttonText = [
  t("work_family_balance.absolutely"),
  t("work_family_balance.somewhat"),
  t("work_family_balance.work_life_balance"),
  t("work_family_balance.prefer_not_to_say"),
];
const data = {
  male: {
    src: addS3Url("/workBalance/work-balance.jpg"),
    placeHolderImage: phMale,
  },
  female: {
    src: addS3Url("/workBalance/work-balance-female.jpg"),
    placeHolderImage: phFemale,
  },
};

const WorkLifeBalance = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const gender = params.gender || "female";

  const handleNavigate = () => {
    nextPageRoute(
      navigate,
      `/${params.gender}/worksituation`,
      dispatch,
      imagesToPreload
    );
  };

  return (
    <MobileViewLayout>
      <div className="px-4 d-flex flex-column justify-content-center align-items-center">
        <h2 className="text-black fw-bold text-center remote-work-header m-0 fs30 remote-selection-heading">
          <Trans
            i18nKey={"work_family_balance.question"}
            components={{ tag: <br /> }}
          />
        </h2>
        <div className="d-flex flex-row w-100 justify-content-between align-items-center income-slab-option ">
          <div className="d-flex" style={{ width: "45%" }}>
            <ImageLoader
              {...data[gender]}
              alt="income level"
              className="work-balance-image"
            />
          </div>

          <div className="w-50  d-flex flex-column gap-1">
            {buttonText.map((item, index) => (
              <button
                tabIndex="0"
                key={index}
                onClick={handleNavigate}
                className="my-2 btn container-fluid rounded-2 d-flex align-items-center px-1 py-2 object-fit-contain link-underline link-underline-opacity-0 justify-content-center work-balance-link button-highlight"
                style={{ backgroundColor: "#F2F2F2" }}
              >
                <p className="m-0 p-0 fw-bold remote-button-text worklife-text ">
                  {item}
                </p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default WorkLifeBalance;
